/**
 * 使用 indexedDB 进行大建模缓存
 */
const DB_NAME = 'reservoir'
const DB_VERSION = 5 // Use a long long for this value (don't use a float)
const DB_STORE_NAME = 'model_glb'
var db
var connect
var needDel
async function put(url, onProgress) {
  let rs = await fetch(url, { method: 'get' })

  if (rs.status === 200) {
    let blob = null;
    try {
      blob = await rs.arrayBuffer();
    } catch (e) {
      // console.log('请求arrayBuffer失败,用blob方式')
      rs = await fetch(url, { method: 'get' })
      blob = await rs.blob();
    }
    let obj = {
      ssn: url
    }
    obj.blob = new Blob([blob], { type: 'model/gltf+json' })
    let inputRequest = db
      .transaction([DB_STORE_NAME], "readwrite")
      .objectStore(DB_STORE_NAME)
      .add(obj);
    return new Promise((resolve, reject) => {
      inputRequest.onsuccess = function () {
        // console.log("glb数据添加成功");
        resolve(obj.blob)
      };
      inputRequest.onerror = function (evt) {
        // console.log("glb数据添加失败", evt);
        reject(new Error('no data'))
      };
    })
  }
}
export async function get(url, onProgress) {
  try {
    // 防止indexedDB报错 影响建模加载
    if (needDel) {
      // 数据库版本更新 清空数据库数据
      db.transaction(DB_STORE_NAME, "readwrite").objectStore(DB_STORE_NAME).clear()
      needDel = false
    }
    // 这个不知道为啥有时升级数据库会报错 找不到原因 就先捕获异常重新请求吧
    let getRequest = db.transaction(DB_STORE_NAME, "readwrite").objectStore(DB_STORE_NAME).get(url);
    return new Promise((resolve, reject) => {
      getRequest.onsuccess = function (event) {
        let modelFile = event.target.result;
        // 假如已经有缓存了 直接用缓存
        if (modelFile) {
          resolve(modelFile.blob)
        } else {
          // 假如没有缓存 请求新的模型存入
          put(url, onProgress).then((blob) => {
            resolve(blob)
          }).catch(() => {
            reject(new Error('no data'))
          });
        }
      };
      getRequest.onerror = function (event) {
        reject(new Error('no data'))
      }
    })
  } catch {
    // indexedDB 报错
    return new Promise(async(resolve, reject) => {
      let rs = await fetch(url, { method: 'get' })
      if (rs.status === 200) {
        let blob = null;
        try {
          blob = await rs.arrayBuffer();
        } catch (e) {
          // console.log('请求arrayBuffer失败,用blob方式')
          rs = await fetch(url, { method: 'get' })
          blob = await rs.blob();
        }
        blob = new Blob([blob], { type: 'model/gltf+json' })
        resolve(blob)
      } else {
        reject(new Error('no data'))
      }
    })
  }
}
export function initDataBase() {
  // 浏览器兼容
  let indexedDB = window.indexedDB ||
      window.mozIndexedDB ||
      window.webkitIndexedDB ||
      window.msIndexedDB;
  // 创建表
  connect = indexedDB.open(DB_NAME, DB_VERSION);
  // onupgradeneeded 仅在表创建及版本号更新时运行
  connect.onupgradeneeded = function(event) {
      db = event.currentTarget.result;
      // 之前没有表 创建表
      if (event.oldVersion === 0) {
        db.createObjectStore(DB_STORE_NAME, {
          keyPath: 'ssn'
        })
      } else {
        // 无法获取objectStore对象 不能做清空表的操作 故给标识 在能获取的时候 进行删除
        needDel = true
      }
  }
  connect.onsuccess = function (event) {
    db = event.currentTarget.result;
  }
  connect.onerror = function (event) {
    console.log(event, '数据库创建失败')
  }
}